/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import './sitemap/s-sitemap-kentico';
import './text-block/s-text-block';
import './agent-search/s-agent-search';
import './video-embed/s-video-embed';
import './desktop-header/s-desktop-header';
import './fees/s-fees';
import './location-and-status/s-location-and-status';
import './upcoming-events/s-upcoming-events';
import './tile-grid/s-tile-grid';
import './scholarship-options/s-scholarship-options';
import './notification-banner/s-notification-banner';
import './openday-landing/s-openday-landing';
import './image-viewer/s-image-viewer';
